module.exports = "<template>\r\n    <span class.bind=\"getTextClass(value)\">${value| currencyFormat : options}</span>\r\n</template>";